import { Link, Navigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { ROLE_LABEL, userRoles, type SaasRole } from '../utils/roles';
import type { ReactNode } from 'react';

export default function ProtectedRoute({
  children,
  requireRole,
}: {
  children: ReactNode;
  /** Perfis que liberam a rota — usuário passa se tiver QUALQUER um deles. */
  requireRole?: SaasRole[];
}) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-canvas text-fg-2">
        <div>Carregando…</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  const mine = userRoles(user);
  if (requireRole && !mine.some((r) => requireRole.includes(r))) {
    // Todo mundo enxerga o menu inteiro (Fase 33), então essa tela é o
    // ponto onde o bloqueio é explicado — precisa ser clara, não um beco.
    return (
      <div className="p-6 md:p-10 max-w-3xl mx-auto">
        <div className="bg-surface border border-line rounded-2xl p-10 text-center">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-danger-soft/30 text-danger flex items-center justify-center mb-4">
            <Lock size={26} />
          </div>
          <h2 className="text-lg font-semibold text-fg">Acesso negado</h2>
          <p className="text-sm text-muted mt-2">
            Esta página requer um dos perfis:{' '}
            <span className="text-fg-2">
              {requireRole.map((r) => ROLE_LABEL[r] ?? r).join(', ')}
            </span>
            .
          </p>
          <p className="text-sm text-muted mt-1">
            Seu acesso atual:{' '}
            <span className="text-fg-2">
              {mine.length > 0 ? mine.map((r) => ROLE_LABEL[r] ?? r).join(', ') : 'nenhum perfil'}
            </span>
            . Fale com um administrador para liberar.
          </p>
          <Link
            to="/"
            className="inline-block mt-6 px-4 py-2 rounded-lg bg-primary-solid hover:bg-primary text-white text-sm transition"
          >
            Voltar ao Dashboard
          </Link>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
